export default __webpack_public_path__ + "static/media/Picture9.7a73afcb.png";